import * as React from 'react';
import { message } from 'antd';
import CreateStoreForm from '../components/CreateStoreForm';
import { metaSelectors } from '@ui/store/meta';
import { connect } from 'react-redux';
import * as editStoreActions from '@ui/scenes/EditStore/services/actions';
import { LoadableContent, PageNavigation, Separator } from '@ui/components';
import * as actions from '../services/actions';
import { editStoreSelectors } from '..';
import { RouteComponentProps, withRouter } from 'react-router';
import { compressImage } from '../../../utils/helpers';

interface StateToProps {
  cities: any[];
  factories: any[];
  markets: any[];
  collections: any[];
  store: any;
  loading: boolean;
}

interface DispatchToProps {
  editStore: (store: any, file: any) => void;
  loadStore: (StoreId: string) => void;
}

class EditStore extends React.PureComponent<
  StateToProps & DispatchToProps & RouteComponentProps
> {
  state = { file: null };

  componentDidMount(): void {
    const { loadStore, match } = this.props;
    const { storeId } = match.params as any;
    loadStore(storeId);
  }

  handleEditStore = () => {
    const { form } = this.formRef.props;
    const { file } = this.state;

    form.validateFields((err: any, values: any) => {
      const { editStore, store } = this.props;
      if (err) {
        return;
      }

      editStore({ ...store, ...values }, file);
    });
  };

  handleValuesChange = (changedValues: any) => {
    const { file } = changedValues;
    if (file) {
      const isImage = file.file.type.match('image.*');
      if (!isImage) {
        message.error('Файл должен быть КАРТИНКОЙ');
        return;
      }
      const isLt500k = file.file.size / 1024 / 1024 < 0.5;
      if (!isLt500k) {
        const reader = new FileReader();
        reader.readAsDataURL(file.file);
        reader.onload = function (e) {
          const img = new Image();
          img.onload = () => {
            compressImage(img, file.file.type, file.file.name, (f: any) => {
              f.uid = `rc-upload-${f.lastModified}-2`;
              file.fileList = [f];
              file.file = f;
            });
          };
          // @ts-ignore
          img.src = e.target.result;
        };
      }
      this.setState({ file });
    }
  };

  saveFormRef = (formRef: any) => {
    this.formRef = formRef;
  };
  private formRef: any;

  render() {
    const {
      cities,
      factories,
      markets,
      collections,
      store,
      loading,
    } = this.props;
    const { file } = this.state;

    return (
      <div className="create-store-form">
        <LoadableContent loading={loading || !store}>
          <PageNavigation
            title={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {store?.city ? store.city.name : ''}
                <Separator />
                {store ? store.name : ''}
              </span>
            }
          />
          <CreateStoreForm
            // @ts-ignore
            onCreate={this.handleEditStore}
            wrappedComponentRef={this.saveFormRef}
            cities={cities}
            factories={factories}
            markets={markets}
            onFieldsChange={this.handleValuesChange}
            collections={collections}
            file={file}
            store={store}
          />
        </LoadableContent>
      </div>
    );
  }
}

const mapStateToProps = (state: any): StateToProps => ({
  cities: metaSelectors.getCities(state),
  factories: metaSelectors.getFactories(state),
  markets: metaSelectors.getMarkets(state),
  collections: metaSelectors.getCollections(state),
  store: editStoreSelectors.getEditStore(state),
  loading: editStoreSelectors.getLoading(state),
});

const mapDispatchToProps = {
  editStore: editStoreActions.editStoreRequested,
  loadStore: actions.loadStoreRequested,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EditStore),
);



// WEBPACK FOOTER //
// ./src/scenes/EditStore/containers/EditStore.tsx